const Gmail = () => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="social-icon hoverable"
      aria-label="Send Email to Shakeel Haider"
    >
      <g clipPath="url(#clip0_141_169)">
        <path
          d="M170 0H30C13.4315 0 0 13.4315 0 30V170C0 186.569 13.4315 200 30 200H170C186.569 200 200 186.569 200 170V30C200 13.4315 186.569 0 170 0Z"
          fill="white"
        />
        <path d="M46.875 153.125V59.0137H153.125V153.125" fill="#F2F2F2" />
        <path
          d="M100 111.328L46.875 153.125L45.3125 70.3125"
          fill="black"
          fillOpacity="0.05"
        />
        <path
          d="M46.875 153.125H37.8906C33.2031 153.125 29.2969 149.219 29.2969 144.141V55.8594H46.875V153.125Z"
          fill="#D54C3F"
        />
        <path
          d="M123.828 153.125H153.906V62.1094H32.0312"
          fill="black"
          fillOpacity="0.08"
        />
        <path d="M37.8906 47.2656H162.109L100 91.4062" fill="#F2F2F2" />
        <path
          d="M153.125 153.125H162.109C166.797 153.125 170.703 149.219 170.703 144.141V55.8594H153.125V153.125Z"
          fill="#B63524"
        />
        <path
          d="M37.8906 55.8594L100 100.781L162.109 55.8594"
          stroke="#DE5145"
          strokeWidth="18"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_169">
          <rect width="200" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Gmail;
